import { hover } from "@testing-library/user-event/dist/hover";
import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Text,
  LabelList
} from "recharts";


const CompassStackedChart = ({ categories, data, YAxisLabel, isArchlet=false }) => {

  const [hoveredBar, setHoveredBar] = useState(null);

  const handleMouseEnter = (dataKey, index, value) => {
    setHoveredBar({ dataKey, index, value });
  };

  const handleMouseLeave = () => {
    setHoveredBar(null);
  };

  // const CustomLabel = ({ x, y, width, height, value, isHovered }) => {
  //   const displayedValue = hoveredBar?.dataKey + ': ' + hoveredBar?.value;
  //   if (!isHovered) return null;
  //   const cx = x + width / 2;
  //   const cy = y - 10;
  //   const textColor = "#000"
  //   return (
  //     <>
  //       <rect
  //         x={cx - (displayedValue.length * 3.5) / 2} // Center the rectangle
  //         y={cy - 10} // Adjust height
  //         width={displayedValue.length * 7} // Approximate width based on character count
  //         height={20} // Fixed height
  //         fill="white" // Background color
  //         rx={4} // Rounded corners
  //         ry={4}
  //       />
  //       <Text
  //         x={cx}
  //         y={cy}
  //         fill={textColor}
  //         fontSize={12}
  //         fontWeight="normal"
  //         textAnchor="middle"
  //         alignmentBaseline="middle"
  //         style={{ whiteSpace: 'break-spaces', fontSize: 10, zIndex: 10, pointerEvents: "none" }}
  //       >
  //         {displayedValue}
  //       </Text>
  //     </>
  //   );
  // };

  const calculatedData = data?.map((entry) => {
    let total = 0;
    if(isArchlet) {
      total = Object.keys(entry)
        .filter((key) => key !== "name")
        .reduce((sum, key) => Number(sum) + Number(entry[key]), 0);
    } else {
      total = Object.keys(entry)
        .filter((key) => key !== "name")
        .reduce((sum, key) => parseFloat(Number(sum).toFixed(2)) + parseFloat(Number(entry[key]).toFixed(2)), 0);


    }
    
    return {
      ...entry,
      total,
      temp: 0,
    };
  });


  const barHeight = 30; // Height for each bar
  const barSize = 40; // Bar thickness
  const chartHeight = (data.length * barHeight) + 200; // Dynamic height

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      // Filter out zero and null values to show only hovered segment values
      const filteredData = payload.filter(item => item.value !== 0 && item.value !== null && item.name === hoveredBar?.dataKey);
      if (filteredData.length > 0) {

        return (
          <div style={{ backgroundColor: "white", padding: "5px", border: "1px solid #ccc", borderRadius: "10px", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", }}>
            {filteredData.map((data, index) => (
              <p key={index} style={{ color: data.fill, margin: 0 }}>
                {`${data.name}: ${data.value}`}
              </p>
            ))}
          </div>
        );
      } else {
        return null;
      }
    }
    return null;
  };


  return (
    <div style={{ width: "100%", height: chartHeight }}>
      {/* <div style={{ width: '100%', height: `${data.length * 50}px` }}> */}
      <ResponsiveContainer width="100%" height={chartHeight}>
        <BarChart
          layout="vertical"
          data={calculatedData}
          margin={{ top: 20, right: 80, left: 20, bottom: 20 }}
        >
          <CartesianGrid horizontal={false} vertical={true} stroke="#DFDFDF" />
          <YAxis dataKey="name" type="category" tickLine={false} width={80} />
          <XAxis type="number" axisLine={false} tickLine={false}
            label={
              isArchlet ? { value: "Number of Bid Events"
            , textAnchor: "middle",
              dy: 20,
              style: { fontSize: "16px", fontWeight: "700", fill: "#616161" }}
              :null
            }

          />

          <Tooltip content={<CustomTooltip />} cursor={false} />

          {categories?.map((category) => {
            const key = category.name;
            const color = category.color;
            return <Bar
              key={key}
              dataKey={key}
              stackId="a"
              fill={color}
              onMouseEnter={(e, index) => handleMouseEnter(key, index, e[key])}
              onMouseLeave={handleMouseLeave}
              barSize={barSize}
            />
          }
          )}
          <Bar dataKey={"temp"} stackId="a" fill={"transparent"} barSize={barSize}>
            <LabelList dataKey="total" position="right" offset={10}
              style={{ fontWeight: 900, color: "#3A3A3A" }} 
              // formatter={(value) => value.toFixed(2)} 
                 formatter={(value) => isArchlet ? value: value.toFixed(2)} 
              />

          </Bar>
        </BarChart>
      </ResponsiveContainer>
      {/* </div> */}
    </div>
  );
};

export default CompassStackedChart;
